import PeopleIcon from "@mui/icons-material/People";
import { IconButton, SxProps, Tooltip } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import React from "react";
import { useIntl } from "react-intl";
import {
  OrganizationUserDetails,
  OrganizationUserListItem,
} from "services/KnowfullyAdminClient";
import authStore from "stores/authStore";

type ImpersonateUserButtonProps = {
  user: OrganizationUserListItem | OrganizationUserDetails;
  color?: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
};

const getStyles = (
  color: string,
  fullWidth: boolean
): { [key: string]: SxProps } => ({
  impersonateButton: {
    color: color,
    textDecoration: "none",
    width: fullWidth ? "100%" : undefined,
    height: "100%",
    borderRadius: "50%",
    "&:focus": {
      outline: "none",
    },
  },
});

const ImpersonateUserButton = ({
  user,
  color = "white",
  size,
  fullWidth = false,
}: ImpersonateUserButtonProps) => {
  const { formatMessage: t } = useIntl();
  const { impersonateRedirectUrl } = useGlobalContext();

  const styles = getStyles(color, fullWidth);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();

    if (!authStore.getRawState().isLoggedIn) {
      e.preventDefault();
      return;
    }
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Tooltip title={t({ id: "impersonationMessage" })} disableInteractive>
      <IconButton
        component="a"
        href={impersonateRedirectUrl(user.id)}
        onClick={handleClick}
        onContextMenu={handleContextMenu}
        size={size}
        sx={styles.impersonateButton}
      >
        <PeopleIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ImpersonateUserButton;
